/**
 * Accesos especiales del PMIS por email.
 *
 * **Estado actual (post ADR Gerencia)**: la allowlist por email quedó VACÍA
 * porque el único acceso especial que existía (Rafael García a Beneficio)
 * ahora se obtiene vía rol `ADMIN_PMIS` — Rafael tiene ese rol como
 * secundario y lo activa al login. Cuando entra como PL2 (operación diaria),
 * NO ve Beneficio; cuando entra como Administrador del PMIS, sí.
 *
 * Mantenemos el módulo y el helper `puedeVerBeneficio` para futuras
 * excepciones puntuales: si en el futuro un stakeholder externo (consultor,
 * auditoría) necesita acceso a Beneficio sin ser ADMIN_PMIS, basta con
 * agregar su email a `BENEFICIO_VIEWERS` y queda autorizado.
 */

export const BENEFICIO_VIEWERS = new Set<string>([
  // Vacía. Rafael García accede vía rol ADMIN_PMIS, no por allowlist.
]);

/**
 * Verifica si el usuario tiene acceso al módulo Beneficio.
 *
 * Reglas:
 *   - ADMIN_PMIS: siempre. (Short-circuit por rol.)
 *   - Cualquier email en `BENEFICIO_VIEWERS`: sí, para casos especiales.
 *   - Resto: no.
 */
export function puedeVerBeneficio(opts: {
  email: string;
  role: string | null;
}): boolean {
  if (opts.role === "ADMIN_PMIS") return true;
  return BENEFICIO_VIEWERS.has(opts.email.toLowerCase());
}
